// Firebase configuration for Deadline by Daria
import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCk0srLRZvc1lEki_8t6uYlOVbMAC6fLOY",
  authDomain: "deadline-by-daria.firebaseapp.com",
  projectId: "deadline-by-daria",
  storageBucket: "deadline-by-daria.firebasestorage.app",
  messagingSenderId: "816548235627",
  appId: "1:816548235627:web:a53209f3bde57727cee42e"
};

const VAPID_KEY = "BNumwOQEyUHRnT3GB0oTZT6rm8A2gDoZgjlWLspAb8QH1A_jh9VJ2g5WitjP7PYA75R7c2lOlsnGSTt3DME9zew";

// Initialize Firebase
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Get messaging instance (only if supported)
let messaging = null;

export const initializeMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
      return messaging;
    }
    return null;
  } catch (error) {
    return null;
  }
};

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return null;
    }

    if (!messaging) {
      await initializeMessaging();
    }

    if (!messaging) {
      return null;
    }

    // Register service worker first
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    
    // Get FCM token
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (token) {
      return token;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback) => {
  if (!messaging) {
    initializeMessaging().then(() => {
      if (messaging) {
        onMessage(messaging, callback);
      }
    });
  } else {
    onMessage(messaging, callback);
  }
};

export { app, messaging, VAPID_KEY };
